import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';

// Silence console output in production to hide debug logs
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  // Keep console.error and console.warn for critical reporting, silence others
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.trace = noop;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
